import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { getApplicantPdf } from '../../new-booking-form/new-booking-form.slice';
import './TermsAndConditionOfflinePreview.scss'
import {  useHistory, useParams } from 'react-router-dom';
import GetAppIcon from '@mui/icons-material/GetApp';
import { BOOKING_FORM_STATUS, ERROR_MESSAGE } from '../../../config/constant';
import { toast } from 'react-toastify';
import { useHandleRedirection } from '../../new-booking-form/hooks/useHandleRedirection';
const { REACT_APP_S3_BASE_URL } = process.env;

const TermsAndConditionOfflinePreview = () => {
    const { applicantData,applicantEditPreview } = useSelector((state) => state?.newBookingForm);
    const dispatch = useDispatch();
    const { oppId } = useParams();
    const history= useHistory()
    const { handleRedirection } = useHandleRedirection();
    
  useEffect(() => {
    // if (
    //   applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED ||
    //  (applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED_OFFLINE && applicantData?.formSignedAt) 
    // ) {
    //   window.location.href = `/feedback/${oppId}`;
    // }

    if (applicantData?.bookingFormStatus) {
          handleRedirection();
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData?.bookingFormStatus]);

    const triggerDownload = async (url, pdfname) => {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        document.body.appendChild(a);
        a.download = pdfname;
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
        window.location.href = `/feedback/${oppId}`;
    }


    const downloadPDF = async () => {
        try {
            const response = await dispatch(getApplicantPdf(`/${oppId}`)).unwrap();
            
            if (response) {
                const fileName = response.fileName;
                const pdfUrl = REACT_APP_S3_BASE_URL + "/" + response.unsignedPdf;
                await triggerDownload(pdfUrl, fileName);
            }
        } catch (error) {
        toast.error(ERROR_MESSAGE); 
        }
    }
    
    return (
        <div className="applicantDetailsCard">
            {/* <CommentBox isDisabled={true} value={comment} /> */}
            <div className="saveLater" onClick={downloadPDF}>
                <GetAppIcon className='svg' />
                Download
            </div>
        </div> 
    )
}

export default TermsAndConditionOfflinePreview